export default __webpack_public_path__ + "affd1a28ee19e8c8717710f653be9ef6.mov";